module.exports = __webpack_public_path__ + "92623a6a8d42766c019330206bc1ee67.svg";